// Copyright (c) 2025 Quantellia LLC
// All Rights Reserved

// import $ from 'jquery';
import { cddinvis } from "./cddinvis.js";
import { cddinodi } from "./cddinodi.js";
import { DIModelConverter } from "./fileformatconverter/dimodelconverter.js";

import { setCurrentNetworkBeingDisplayed, 
  currentNetworkBeingDisplayed, myNetworkOptions,
  setUpEventHandlers,
  displayCDD
} from "./grapher.js";

var nodeRadius = 20;
var container;
var visExportArea, odiExportArea;
var importButton;
var exportButton;
var importExportDiv;

var odiCDD; // CDD in odi representation
var visCDD; // CDD in vis.js representation

// function init() {
$(document).ready(function() {
  container = document.getElementById("diagram");
  visExportArea = document.getElementById("vis_input_output");
  odiExportArea = document.getElementById("odi_input_output");
  importButton = document.getElementById("import_button");
  exportButton = document.getElementById("export_button");
  importExportDiv = $("#importexportcontainer");

  const destroyButton = document.getElementById("destroy_button");
  const odiFileImportButton = document.getElementById("odi_file_import_button");
  const odiFileExportButton = document.getElementById("odi_file_export_button");
  const visFileImportButton = document.getElementById("vis_file_import_button");
  const visFileExportButton = document.getElementById("vis_file_export_button");
  const closeIEButton = document.getElementById("close_ie_button");

  if (importButton) {
    importButton.addEventListener("click", importNetworkFromScreen);
  }

  if (exportButton) {
    exportButton.addEventListener("click", exportNetworkToScreenField);
  }

  if (destroyButton) {
    destroyButton.addEventListener("click", destroyNetwork);
  }

  if (odiFileImportButton) {
    odiFileImportButton.addEventListener("click", handleDIModelReadFromODIFile);
  }

  if (odiFileExportButton) {
    odiFileExportButton.addEventListener("click", handleDIModelWriteToODIFile);
  }

  if (visFileImportButton) {
    visFileImportButton.addEventListener("click", handleDIModelReadFromVisFile);
  }

  if (visFileExportButton) {
    visFileExportButton.addEventListener("click", handleDIModelWriteToVisFile);
  }

  if (closeIEButton) {
    closeIEButton.addEventListener("click", closeImportExportWindow);
  }

  clearOutputAreas();
  //draw();
});

export function addConnections(elem, index) {
  // need to replace this with a tree of the network, then get child direct children of the element
  elem.connections = currentNetworkBeingDisplayed.getConnectedNodes(index);
}

export function destroyNetwork() {
  currentNetworkBeingDisplayed.destroy();
}

export function clearOutputAreas() {
  visExportArea.value = "";
  odiExportArea.value = "";
}

export function draw() {
  // create a network of nodes
  //var data = getScaleFreeNetwork(5);

  // network = new vis.Network(container, graphData, {
  //   manipulation: { enabled: true },
  // });

  clearOutputAreas();
}

// This is the function that's called when you press the "export" button
export function exportNetworkToScreenField() {

  // TODO needs to save the file, not just display it in the outputarea (which is good for testing though)
  clearOutputAreas();

  const networkDataReadyForExport = makeNetworkReadyForExport();

  visExportArea.value = JSON.stringify(networkDataReadyForExport);

  resizeVisExportArea();
}

// Make various changes to the network so that it exports
// correctly.  Note that I got this from the vis.js samples
// code archive, so there are parts here whose purpose I don't
// understand
function makeNetworkReadyForExport() {

  // Obtain the x and y positions of nodes so that we can retain them on subsequent import
  var nodesWithPositions = objectToArray(currentNetworkBeingDisplayed.getPositions());

  // TODO do we still need this connection info?  I think it's not needed, but leaving here for now
  nodesWithPositions.forEach(addConnections);

  // // TODO: consider storing in a standard grpah format, like gephi: the library only imports from gephi, not exports
  // // TODO: more node attributes to export
  // // TODO: export link attributes
  // // TODO: store network somewhere, not just in a window!
  // // pretty print node data
  // var exportValue = JSON.stringify(nodes, undefined, 2);
  var basicNetworkInfo = exportNodesToJSON();

  // Now need to merge position info with the basic node info 
  // I now have two objects:
  // 1: nodesWithPositions is an array of nodes, each of which is an object with several characteristics, including especially their x and y positions
  // 2: basicNetworkInfo: an object with two arrays, one of which is called "nodes", the other is called "edges"
  // The code below creates a new object where: 
  // 1) it contains an array of edges that match the ones from basicNetworkInfo, above
  // 2) it contains an array of nodes, where the properties of the nodes are from the two sources listed above. When there is a property with the same name in both sources, the informatino in nodesWithPermissions should win
  // Create a mapping of nodes with their IDs from nodesWithPositions for easy access
  const nodesMap = {};
  nodesWithPositions.forEach(node => {
    nodesMap[node.id] = node;
  });

  // Merge nodes with the same ID from basicNetworkInfo into nodesMap
  basicNetworkInfo.nodes.forEach(node => {
    if (nodesMap[node.id]) {
      // Merge the properties of the node from basicNetworkInfo into nodesMap
      Object.assign(nodesMap[node.id], node);
    } else {
      // If the node doesn't exist in nodesWithPositions, add it to nodesMap
      nodesMap[node.id] = { ...node };
    }
  });

  // Convert the nodesMap object back to an array of nodes
  const combinedNodes = Object.values(nodesMap);

  // The combined data object with unique nodes and original edges
  const networkDataReadyForExport = {
    nodes: combinedNodes,
    edges: basicNetworkInfo.edges,
  };
  return networkDataReadyForExport;
}

export function importNetworkFromScreen() {
  var jsonCDDString = visExportArea.value;
  renderCDDFromNewData(jsonCDDString);
  // displayCDD("easeOutQuart", jsonCDDString);
}

export function renderCDDFromNewData(jsonCDDString) {
  var inputData = JSON.parse(jsonCDDString);

  // In the sample code on the viz site, it included the following code
  // to modify the data field.  I'm not sure why, because I think that
  // we wrote it out in a valid format, so can just use that for the network,
  // right?
  // var data = {
  //   nodes: getNodeData(inputData.nodes), // Not sure why this is needed.
  //   edges: getEdgeData(inputData.edges),
  // };
  // network = new vis.Network(container, data, myOptions);
  // let test = new vis.Network(container, inputData, myNetworkOptions);

  // currentNetworkBeingDisplayed = new vis.Network(container, inputData, myNetworkOptions);
  setCurrentNetworkBeingDisplayed(new vis.Network(container, inputData, myNetworkOptions));
  setUpEventHandlers(currentNetworkBeingDisplayed);

  resizeVisExportArea();
}

export function getNodeData(nodes) {
  var networkNodes = [];

  nodes.forEach(function (elem, index, array) {
    networkNodes.push({
      id: elem.id,
      label: elem.id,
      x: elem.x,
      y: elem.y,
    });
  });

  return new vis.DataSet(networkNodes);
}

export function getNodeById(data, id) {
  for (var n = 0; n < data.length; n++) {
    if (data[n].id == id) {
      // double equals since id can be numeric or string
      return data[n];
    }
  }

  throw "Can not find id '" + id + "' in data";
}

// TODO I don't understand why this function is needed.  
export function getEdgeData(data) {
  var networkEdges = [];

  data.forEach(function (node) {
    // add the connection
    node.connections.forEach(function (connId, cIndex, conns) {
      networkEdges.push({ from: node.id, to: connId });
      let cNode = getNodeById(data, connId);

      var elementConnections = cNode.connections;

      // remove the connection from the other node to prevent duplicate connections
      var duplicateIndex = elementConnections.findIndex(function (
        connection
      ) {
        return connection == node.id; // double equals since id can be numeric or string
      });

      if (duplicateIndex != -1) {
        elementConnections.splice(duplicateIndex, 1);
      }
    });
  });

  return new vis.DataSet(networkEdges);
}

export function objectToArray(obj) {
  return Object.keys(obj).map(function (key) {
    obj[key].id = key;
    return obj[key];
  });
}

export function resizeVisExportArea() {
  visExportArea.style.height = 1 + visExportArea.scrollHeight + "px";
}

export function resizeODIExportArea() {
  odiExportArea.style.height = 1 + odiExportArea.scrollHeight + "px";
}


// Exporting node characteristics to a JSON object
export function exportNodesToJSON() {
  const nodes = currentNetworkBeingDisplayed.body.data.nodes.get(); // Access the current nodes data
  const edges = currentNetworkBeingDisplayed.body.data.edges.get(); // Access the current edges data

  // Create an array to store node characteristics
  const nodesDataExport = [];

  // TODO: the fixed property isn't getting exported.  Need to fix this bug
  nodes.forEach(node => {
    // Extract the node's characteristics that you want to save
    const nodeCharacteristics = {
      id: node.id,
      label: node.label, 
      fixed: node.fixed,
      elementtype: node.elementtype,
      elementname: node.elementname,
      font: node.font,
      // TODO whenever we have a characteristic of the nodes that we want to allow the user to edit - and that they would 
      // reasonably expect to be preserved on import/export - that characteristic needs to be added here using
      // the format shown above.
      // For example:
      // title: node.title,
      // color: node.color,
      // shape: node.shape,
      // ...
    };

    nodesDataExport.push(nodeCharacteristics);
  });

  // Create a JSON object to store the node data
  const jsonData = {
    nodes: nodesDataExport,
    edges: edges, // Include the edges data as well if needed
  };

  // Return or do something with jsonData (e.g., store in Local Storage, send to server, etc.)
  return jsonData;
}

//init();

  // Function to show the import/export dialogue
export function showImportExport() {
    if (!importExportDiv) {
      console.error("missing importexportcontainer. can't display dialogue.");
      return;
    }
    importExportDiv.removeClass("hidden").addClass("importexportcontainer")
  }

export function closeImportExportWindow() {
    importExportDiv.addClass("hidden").removeClass("importexportcontainer");
}



export async function handleDIModelReadFromVisFile() {
  try {
    // If we haven't initialized  the myModel object yet, then do so
    if (!visCDD) {
      const tempData = [{ "fieldName": "fieldValue" }];
      visCDD = new cddinvis();
    }
    await visCDD.read();
    console.log("File content:", visCDD.data);
    // You can do further processing with cddinvis.data here
    // TODO: Load this model's data into the screen CDD
    //renderCDDFromNewData(visCDD.data);
    displayCDD("easeOutQuart", visCDD.data);
  } catch (error) {
    console.error("Error reading decision file:", error);
  }
}

export async function handleDIModelWriteToVisFile() {

  try {
    // TODO need to initialize myModel when we display it on demoCDD or similar
    // START HERE
    await visCDD.write();
    console.log("Data was successfully written to a file.");
  } catch (error) {
    console.error("Error while writing di model to a file:", error);
  }
}

// Reads from an ODI file, converts to vis, and renders
export async function handleDIModelReadFromODIFile() {
  // alert("Read ODI from file");
  // return;

  try {
    // If we haven't initialized  the myModel object yet, then do so
    if (!visCDD) {
      // const tempData = [{ "fieldName": "fieldValue" }];
      visCDD = new cddinvis();
    }

    if (!odiCDD) {
      odiCDD = new cddinodi();
    }

    await odiCDD.read();

    // TODO: Note that this takes a string - not a json - as input, so it needs to be converted
    // So we probably want to change this so it expects an object.
    let visCDDJSONString = DIModelConverter.ODIToVis(odiCDD.data);

    if (!visCDDJSONString) {
      console.error("Failed to convert ODI to vis");
      return;
    }

    visCDD.data = JSON.parse(visCDDJSONString);

    // TODO: maybe only do this based on a config flag?
    visExportArea.value = visCDDJSONString;
    odiExportArea.value = JSON.stringify(odiCDD.data);
    
    // console.log("File content:", visCDD.data);
    // You can do further processing with cddinvis.data here
    // TODO: Load this model's data into the screen CDD
    // renderCDDFromNewData(visCDD.data);
    renderCDDFromNewData(visCDDJSONString);
  } catch (error) {
    console.error("Error reading ODI CDD file: " + error + error.stack);
  }
}

export async function handleDIModelWriteToODIFile() {
  // alert("Write ODI to file");

  // TODO is this right?  Don't we only create a visCDD on export?
  if (!visCDD) {
    alert("Create a CDD before writing it out please")
    return;
  }

  // It's possible that we've edited the CDD on the screen but haven't
  // synced it into the visCDD object.  Do that now, in case this
  // is the case
  visCDD.data = makeNetworkReadyForExport(currentNetworkBeingDisplayed);

  // Create the odi version of the CDD and store it an odiCDD object
  // TODO: Note that this takes a string - not a json - as input, so it needs to be converted
  // So we probably want to change this so it expects an object.
  let convertedVis = DIModelConverter.VisToODI(JSON.stringify(visCDD.data));

  if (!convertedVis) {
    console.error("Failed to convert vis to odi");
    return
  }

  odiCDD = new cddinodi( convertedVis );
  
  // TODO maybe this should be optional / configurable?
  odiExportArea.value = odiCDD.data;
  resizeODIExportArea(); 

  try {
    await odiCDD.write();
    console.log("odi data was successfully written to a file.");
  } catch (error) {
    console.error("Error while writing di model to a file:", error);
  }
}

//
// ES6-compliant decision model manipulation test harness
//
export async function testDIScaffold() {
  //import { DiDecisionModelView } from './diDecisionModelView';

  const data = [{ "fieldName": "fieldValue" }]; // Your data here

  const myModel = new cddinvis(data);

  /////
  // Test read()
  /////
  try {
    await myModel.read();
    console.log("File content:", myModel.data);
    // You can do further processing with dimodelrw.data here
  } catch (error) {
    console.error("Error reading file:", error);
  }

  /*
 // myModel.parse();
  myModel.validate();
  myModel.write();
  myModel.transform();
  myModel.render();
  */

  /*
  const myModelView = new DiDecisionModelView(myModel);
  myModelView.render();
  myModelView.pan();
  myModelView.zoom();
  */

}